<script lang="ts">
  import {onDestroy} from "svelte";
  import {Label} from "../../../constants/label";
  import TrendingQueryListItem from "./TrendingQueryListItem.svelte";
  import {SqrlTestId} from "../../../constants/squirrel";
  import {keywords} from "../../../store/SuggestionStore";
  import {timeEmptyState, timeSuggestRender} from "../../../times/TimeFactory";
  import {indexStore} from "../../../store/IndexStore";

  timeEmptyState.mark()

  const unsubscribe = keywords.subscribe((keywords) => {
    indexStore.updateMaxIndex(keywords.length);
  })

  timeSuggestRender.measure();
  onDestroy(() => {
    timeEmptyState.measure()
    unsubscribe();
  })
</script>

<div class="squirrel_trendingQueries pl_table-view" data-testid={SqrlTestId.TRENDING_QUERY_LIST}>
    <div class="pl_table-view--headline squirrel_searchSuggestions__headline">
        <span class="pl_copy75">{Label.TRENDING_QUERY_HEADER}</span>
    </div>
    <ul class="squirrel_trendingQueries__list squirrel_border_top">
        {#each $keywords as trendingQuery, index}
            <TrendingQueryListItem {index} {trendingQuery}/>
        {/each}
    </ul>
</div>

<style lang="scss">
  @use "~@otto-ec/global-frontend-settings/scss/pl_variables" as pl_variables;

  .squirrel_trendingQueries {
    background-color: pl_variables.$pl_color-white100;
    padding: 0;
    border-radius: 0 0 8px 8px;
  }

  .squirrel_searchSuggestions__headline {
    padding: 24px 16px 8px;
    height: auto;
    color: pl_variables.$pl_color-grey400;
  }
</style>
